<span class="math-content" #mathContent [innerHTML]="content"></span>
